import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import { Portal } from "@chakra-ui/portal";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import { ProtectedRoute, routes } from "routes";
import { matchPath } from "react-router";
import NotFound from "views/errors/404";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState([
    { name: "Dashboard", path: "/dashboard" },
  ]);
  React.useEffect(() => {
    const onResize = () => {
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    };

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
    // eslint-disable-next-line
  }, [location.pathname]);
  // functions for changing the states from components
  const getActiveRoute = (routes, activeRoute) => {
    activeRoute ||= [];
    for (let i = 0; i < routes.length; i++) {
      if (!matchPath(routes[i].layout + routes[i].path, location.pathname))
        continue;

      if (routes[i].collapse) {
        activeRoute = [
          ...activeRoute,
          {
            name: routes[i].name,
            title: routes[i].title,
            path: routes[i].layout + routes[i].path,
          },
        ];
        let collapseActiveRoute = getActiveRoute(routes[i].items, activeRoute);
        if (!collapseActiveRoute) {
          setCurrentRoute(activeRoute);
        }
      } else {
        setCurrentRoute([
          ...activeRoute,
          {
            name: routes[i].name,
            title: routes[i].title,
            path: routes[i].layout + routes[i].path,
          },
        ]);
        return true;
      }
    }
    return null;
  };
  const getRoutes = (routes) => {
    const reducer = (ret, prop) => {
      if (prop.layout === "/admin") {
        ret.push({ path: prop.path, component: prop.component });
        prop.collapse && prop.items.reduce(reducer, ret);
      }
      return ret;
    };

    return routes.reduce(reducer, []).map((prop, key) => {
      return (
        <Route
          path={`${prop.path}`}
          element={<ProtectedRoute>{prop.component}</ProtectedRoute>}
          key={key}
        />
      );
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full bg-background-100 dark:bg-background-900 dark:text-white">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full font-dm dark:bg-background-900">
        {/* Main Content */}
        <main
          className={`mx-2.5 flex-none transition-all dark:bg-background-900 md:pr-2 xl:ml-[290px]`}
        >
          {/* Routes */}
          <div>
            {/* <Portal> */}
            <Navbar
              onOpenSidenav={() => setOpen(!open)}
              brandText={currentRoute}
              {...rest}
            />
            {/* </Portal> */}
            <div className="flex flex-col mx-auto min-h-[calc(100vh_-_92px)] pt-[0px] sm:pt-[10px]">
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/admin/dashboard" replace />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
